import {useQuery, gql} from "@apollo/client";
var ANNOUNCEMENT_DETAIL = gql`
  query announcement($alias: String = " ") {
    announcement(where: {alias: {alias: $alias}, localization: {culture_starts_with: "fa"}}) {
      bag {
        contentItems {
          ... on AnnouncementDownload {
            createdUtc
            displayText
            announcementFile {
              urls(first: 1)
            }
          }
        }
      }
      htmlBody {
        html
      }
      displayText
      announcementDate
      announcementIcon {
        urls(first: 1)
      }
      alias {
        alias
      }
    }
  }
`;
export const useAnnouncementDetail = (alias) => {
  const {error, data, loading} = useQuery(ANNOUNCEMENT_DETAIL, {
    variables: { alias: alias }
  });
  return {
    error,
    data,
    loading
  }
}